import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Modal, Paragraph } from '@vwfs-bronson/bronson-react';
import { RootState } from '../../services/redux';
import { clearApiError } from '../../services/redux/features/custom.slice';

const isProd = process.env.REACT_APP_STAGE === 'prod';

export const ErrorModal: FunctionComponent = () => {
  const [error, setError] = useState('');
  const [status, setStatus] = useState(null);
  const [translatedError, setTranslatedError] = useState('');
  const [url, setUrl] = useState<string | null>(null);

  const { hasError, errorData, extended } = useSelector((state: RootState) => state.custom.data.apiError);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!hasError) return;
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.error(errorData);
    }

    if (extended) {
      setError(JSON.stringify(errorData, null, 2));
      return;
    }

    const { title, detail, messages } = errorData?.responseData?.message || {};

    if (messages?.length) {
      setTranslatedError(messages[0].translation);
    }

    if (title || detail) {
      setError(detail || title);
    }

    const { status, url } = errorData ?? {};

    if (status) {
      setStatus(status);
    }

    if (url && !isProd) {
      setUrl(url);
    }
  }, [hasError, errorData, extended, t]);

  if (!hasError) return null;

  return (
    <Modal
      id="ErrorModal"
      title={t('error:heading')}
      buttonCancelText="Fermer"
      onCancel={() => {
        dispatch(clearApiError());
      }}
      onClose={() => {
        dispatch(clearApiError());
      }}
      shown
      asPortal
      className="u-font-size-fs-2"
    >
      <Card title="" className="u-text-left" scrollable>
        {extended ? (
          <pre>
            <code>{error}</code>
          </pre>
        ) : (
          <>
            <Paragraph>
              {error} {status ? `${error ? ' ' : ''} (${status})` : ''}
            </Paragraph>
            <Paragraph className="c-blockquote__text u-text-base u-font-size-fs-2">
              {translatedError || t('error:fallbackError')}
            </Paragraph>
            {url?.length && <span className="u-font-size-fs-3">{url}</span>}
          </>
        )}
      </Card>
    </Modal>
  );
};
